module.exports = __webpack_public_path__ + "img/ico_ugc_shorts_on.1a5d841.svg";